import { apiSlice } from "../../app/api/apiSlice";

export const glossaryConfigApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getGlossaryConfig: builder.mutation({
			query: () => ({
				url: "/api/v1/loan/get_glossary_config/",
				method: "GET",
			}),
		}),
	}),
});

export const { useGetGlossaryConfigMutation } = glossaryConfigApiSlice;
